import React, { useEffect } from 'react';
import style from './InteractThree.module.sass'
import Sketch from "react-p5"
import { useInView } from 'react-intersection-observer'

//pause clock sound when not in view
const pauseClock = () => {
    const clockSound = document.querySelector("#clockSoundID");
    clockSound.pause()
}
// add ripple animation when hover clock
const radiate = () => {
    const rippleAni = document.querySelector("#ripple");
    rippleAni.classList.add(`show`)
}
// stop ripple animation when unhover clock
const stopRadiate = () => {
    const rippleAni = document.querySelector("#ripple");
    rippleAni.classList.remove(`show`)
}

class InteractThree extends React.Component {
    constructor(props) {
        super(props)
        this.sketchTwo = React.createRef()
        this.state = {
            showPlus: false,
            sketchTwoWidth: 0,
            sketchTwoHeight: 0,
        }
    }

    //getting cavas size for p5 sketch
    componentDidMount() {
        this.setState({ sketchTwoWidth: this.sketchTwo.current.offsetWidth })
        this.setState({ sketchTwoHeight: this.sketchTwo.current.offsetHeight })
    }
    render() {
        return (
                <div className={`${style.sketchTwoContainer} main`} onLoad = {() => pauseClock()} >
                    <div 
                    ref={this.sketchTwo} 
                    className={`${style.sketchTwo} sketchTwo`}
                    onClick={() => this.setState({ showPlus: !this.state.showPlus })} 
                    >
                        {this.state.showPlus ?
                            <SketchTwoPlus pauseClock = {this.props.pauseClock} theme={this.props.theme}/>
                            :
                            <SketchTwo 
                            showPlus = {this.state.showPlus}
                            playClock = {this.props.playClock}
                            pauseClock = {this.props.pauseClock}
                            theme={this.props.theme}
                            width={this.state.sketchTwoWidth} 
                            height={this.state.sketchTwoHeight} 
                             />
                        }

                    </div>
                </div>

        )
    }

}

class SketchTwo extends React.Component {

    cx;
    cy;
    secondsRadius;
    minutesRadius;
    hoursRadius;
    clockDiameter;
    radius;

    s;
    m;
    h;

    opacity;
    clockColor;
    clockHandColor;

    

    render() {
        return (
            <>
            <Ripple showPlus = {this.props.showPlus} playClock = {this.props.playClock} pauseClock = {this.props.pauseClock}/>
                <div>
                    <Sketch
                        setup={
                            (p5, sketchTwo) => {
                                p5.createCanvas(this.props.width*0.8, this.props.height*0.8).parent(sketchTwo);
                                p5.stroke(255);
                                this.radius = p5.min(p5.width, p5.height) * 0.5
                                this.secondsRadius = this.radius * 0.71;
                                this.minutesRadius = this.radius * 0.6;
                                this.hoursRadius = this.radius * 0.5;
                                this.clockDiameter = this.radius * 1.5;
     
                                this.cx = p5.width / 2;
                                this.cy = p5.height / 2

                                this.clockColor = this.props.theme.eOne;
                                this.clockHandColor = this.props.theme.mainOne;

                            }
                        }
                        draw={
                            p5 => {
                                this.opacity = 0.25
                                // Draw the clock background
                                p5.clear();
                                p5.noStroke();
                                p5.fill(this.props.theme.eOne);
                                p5.ellipse(this.cx, this.cy, this.clockDiameter + 10, this.clockDiameter + 10);
                                p5.fill(this.props.theme.eOne);
                                p5.ellipse(this.cx, this.cy, this.clockDiameter, this.clockDiameter);
                                
                                this.s = p5.map(p5.second(), 0, 60, 0, p5.TWO_PI) - p5.HALF_PI;
                                this.m = p5.map(p5.minute() + p5.norm(p5.second(), 0, 60), 0, 60, 0, p5.TWO_PI) - p5.HALF_PI;
                                this.h = p5.map(p5.hour() + p5.norm(p5.minute(), 0, 60), 0, 24, 0, p5.TWO_PI * 2) - p5.HALF_PI;

                                // Draw the hands of the clock
                                p5.stroke(this.clockHandColor);
                                p5.strokeWeight(1);
                                p5.line(this.cx, this.cy, this.cx + p5.cos(this.s) * this.secondsRadius, this.cy + p5.sin(this.s) * this.secondsRadius);
                                p5.strokeWeight(2);
                                p5.line(this.cx, this.cy, this.cx + p5.cos(this.m) * this.minutesRadius, this.cy + p5.sin(this.m) * this.minutesRadius);
                                p5.strokeWeight(4);
                                p5.line(this.cx, this.cy, this.cx + p5.cos(this.h) * this.hoursRadius, this.cy + p5.sin(this.h) * this.hoursRadius);

                                if (
                                    p5.mouseX >= this.cx - this.clockDiameter/2 &&
                                    p5.mouseX <= this.cx + this.clockDiameter/2 &&
                                    p5.mouseY >= this.cy - this.clockDiameter/2 &&
                                    p5.mouseY <= this.cy + this.clockDiameter/2
                                  ) {
                                    // this.cx += p5.random(-3, 3);
                                    // this.cy += p5.random(-3, 3);
                                   this.clockHandColor =  this.props.theme.titleOne;
                                    radiate();
                                    // playSoundFile();
                                    // this.props.playClock()
                                  } else {
                                    this.clockHandColor =  this.props.theme.mainOne;
                                    stopRadiate();
                                  }
                                // Draw the minute ticks
                                p5.strokeWeight(2);
                                p5.beginShape(p5.POINTS);
                                for (let a = 0; a < 360; a += 6) {
                                    let angle = p5.radians(a);
                                    let x = this.cx + p5.cos(angle) * this.secondsRadius;
                                    let y = this.cy + p5.sin(angle) * this.secondsRadius;
                                    p5.vertex(x, y);
                                }
            
                                p5.endShape();


                            }
                        }
                    />
                </div>
            </>
        )
    }

}

const Ripple = (props) => {

    const [ref, inView] = useInView({})

    useEffect(() => {
     if (inView) {
        props.playClock()    
      } else {
          props.pauseClock()
      }
    })

      return (
          <>
        <div ref = {ref} className = "ripple" id = "ripple" >
          <div></div>
          <div></div>
        </div>
        </>
      )
   
}

class SketchTwoPlus extends React.Component{

    render() {
        return (

            <>
            <div className = {style.endoTextContainer}>
                <div className = {`${style.endoText} endoText`}>
                        <h1> <span>Endometriosis</span> occurs when bits of the tissue that lines the uterus grow on other pelvic organs. It is usually accompanied by <span className = {style.strong}>severe period pain.</span></h1>
                        <h1> <span>1 in 10 women </span>of reproductive age in the UK suffer from endometriosis. So why don’t we hear about it? </h1>
                        <h1> <span>Time is ticking for change.</span></h1>
                </div>
                
            </div>
            <iframe title = "bubbles" className = {style.sketchTwoPlus} src={this.props.theme.bubbleLink}></iframe>
            </>
         )
     }
    }
   
export default InteractThree


//initial way of controlling clock sound
// let options = {
//     root: document.querySelector('#root'),
//     rootMargin: '0px',
//     threshold: 1.0
//   }

// let callback = (entries, observer) => {
//     entries.forEach(entry => {
//    console.log('in view')
//     });
//   };
    
// let observer = new IntersectionObserver(callback, options);

// observer.observe(this.sketchTwo);